import { FC } from 'react';
import BookitupTable from '../../../Atoms/BookitupTable';
import { BookitupContract } from '../../../Types/BookitupDocument';
import ContractItem from './ContractItem';
import './ContractPaneTable.css';

interface ContractPaneTableProps {
  contracts: BookitupContract[];
  reload: () => void;
}

const ContractPaneTable: FC<ContractPaneTableProps> = ({ contracts, reload }) => (
  <div className="contract-pane-table">
    <BookitupTable>
      <thead>
        <tr>
          <th className="contract-pane__column--status">Status</th>
          <th className="contract-pane__column--number">Nummer</th>
          <th className="contract-pane__column--label">Name</th>
          <th className="contract-pane__column--customer">Vertragspartner:in</th>
          <th className="contract-pane__column--date">Datum</th>
          <th className="contract-pane__column--portal">Portal</th>
          <th> </th>
        </tr>
      </thead>
      <tbody>
        {contracts.map((contract) => (
          <ContractItem
            key={contract.id}
            contract={contract}
            reload={reload}
            showNumber
            showLabel
            showName
            showDatum
            showPortal
            narrowPortalStatus={false}
          />
        ))}
      </tbody>
    </BookitupTable>
  </div>
);

export default ContractPaneTable;
